import { createContext, useContext, type ReactNode } from 'react';
import { useAtmosphere } from './useAtmosphere.js';

/**
 * The room tone belongs to the app, not to the settings dialog.
 *
 * It lived inside the dialog at first, which meant closing the dialog unmounted
 * the hook and silenced everything — the one thing you never want from
 * background sound. It is mounted once here instead, and keeps playing until
 * it is stopped on purpose.
 */
type Atmosphere = ReturnType<typeof useAtmosphere>;

const AtmosphereContext = createContext<Atmosphere | null>(null);

export function AtmosphereProvider({ children }: { children: ReactNode }) {
  const atmosphere = useAtmosphere();
  return <AtmosphereContext.Provider value={atmosphere}>{children}</AtmosphereContext.Provider>;
}

export function useAtmosphereContext(): Atmosphere {
  const value = useContext(AtmosphereContext);
  if (!value) throw new Error('useAtmosphereContext needs an AtmosphereProvider above it');
  return value;
}
